/* ready */
$(function() {
  'use strict';

  // MV
  $('.p-top-fv__mv').slick({
    fade : true,
    autoplay : true,
    autoplaySpeed : 3500,
    speed : 4000,
    dots : true,
    arrows : false,
    swipe: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: false
        }
      }
    ]
  });

  // Topics
  $('.p-top-topics__list').slick({
    autoplay : true,
    autoplaySpeed : 3500,
    speed : 3000,
    slidesToShow: 4,
    swipe: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          swipe: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});